import { Strophe } from "strophe.js";
import "./libs/strophe/strophe.rsm";

import { StrophePlugin } from "./libs/strophe/strophe-plugin";
import { StrophePingPlugin } from "./libs/strophe/strophe.ping";
import { StropheLastActivityPlugin } from "./libs/strophe/strophe.lastactivity";
import { StropheMAMPlugin } from "./libs/strophe/strophe.mam";
import { StropheJinglePlugin } from "./libs/strophe/strophe.jingle";

StrophePlugin.register(StrophePingPlugin, Strophe);
StrophePlugin.register(StropheLastActivityPlugin, Strophe);
StrophePlugin.register(StropheMAMPlugin, Strophe);
StrophePlugin.register(StropheJinglePlugin, Strophe);
